import { useState,useEffect } from 'react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 5); // Change color after scrolling 50px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative w-full">
      {/* Transparent navbar */}
      {/* <nav className={`fixed top-0 left-0 w-full bg-['#20A582'] shadow-lg  z-50`}> */}
      <nav
      className={`fixed top-0 left-0 w-full z-50 shadow-lg transition-colors duration-300 ${
        isScrolled ? 'bg-[#fff]' : 'bg-transparent'
      }`}
    >
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center">
              <a href="/" className="flex items-center">
                <img src="/logo.png" alt="Organic Pads Logo" className="h-16 w-auto" />
              </a>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/products" className="text-[#679729] font-bold transition-colors duration-200">
                Products
              </a>
              <a href="/blogs" className="text-[#679729] font-bold transition-colors duration-200">
                Blogs
              </a>
              <a href="/about" className="text-[#679729] font-bold transition-colors duration-200">
                About Us
              </a>
              <a href="/contact" className="text-[#679729] font-bold transition-colors duration-200">
                Contact
              </a>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden flex items-center">
              <button
                className="text-white hover:text-green-200 focus:outline-none focus:ring-2 focus:ring-green-300 rounded-lg p-2"
                onClick={() => setIsOpen(!isOpen)}
              >
                <span className="sr-only">Open main menu</span>
                <div className="w-6 h-6 relative">
                  {!isOpen ? (
                    <>
                      <span className="block absolute h-0.5 w-6 bg-current transform transition duration-500 ease-in-out">
                        <span className="block absolute h-0.5 w-6 bg-current transform transition duration-500 ease-in-out -translate-y-2"></span>
                        <span className="block absolute h-0.5 w-6 bg-current transform transition duration-500 ease-in-out"></span>
                        <span className="block absolute h-0.5 w-6 bg-current transform transition duration-500 ease-in-out translate-y-2"></span>
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="block absolute h-0.5 w-6 bg-current transform transition duration-500 ease-in-out rotate-45"></span>
                      <span className="block absolute h-0.5 w-6 bg-current transform transition duration-500 ease-in-out -rotate-45"></span>
                    </>
                  )}
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden ${isOpen ? 'block' : 'hidden'}`}>
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-green-600/80 backdrop-blur-sm">
            <a href="/" className="block px-3 py-2 text-white hover:bg-green-500 rounded-md">
              Home
            </a>
            <a href="/products" className="block px-3 py-2 text-white hover:bg-green-500 rounded-md">
              Products
            </a>
            <a href="/about" className="block px-3 py-2 text-white hover:bg-green-500 rounded-md">
              About Us
            </a>
            <a href="/contact" className="block px-3 py-2 text-white hover:bg-green-500 rounded-md">
              Contact
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;